var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-zoom-chip"},[_c('v-btn',{staticClass:"v-btn",class:{ active: _vm.isActive },attrs:{"depressed":"","ripple":false}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }